import "./onwer_info.css"
import review_logo from "../../../assets/logo.svg";
import personal_img from "../../../assets/pers_img.png";
import Logout from "../../logout/Logout";
import React, {useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import {useTranslation} from "react-i18next";
import {Spinner} from "react-bootstrap";
import axios from "axios";
import {connect} from "react-redux";
import {setOwnerData, setOwnerType, setSameAddType, setSpouseType} from "../../../redux/owner_info_store";
import {Link, useNavigate} from "react-router-dom";
import TooltipComponent from "../../country_tooltip/CountryTooltip";
import StateTooltipComponent from "../../state_tooltip/StateTooltip";

const HOST = `${process.env.REACT_APP_API_URL}/api/accounts/step32/`

function OwnerPersonalInfo({
                               ownerData,
                               setOwnerData,
                               personalData,
                               setOwnerType,
                               setSpouseType,
                               setSameAddType,
                               appData
                           }) {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const [isReadyCountry, setIsReadyCountry] = useState(false)
    const [isReadyState, setIsReadyState] = useState(false)
    const [countries, setCountries] = useState([]);
    const [residenceCountry, setResidenceCountry] = useState([]);
    const [states, setState] = useState([])

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/accounts/getCountries`, {
                headers: {
                    "ngrok-skip-browser-warning": "69420",
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            }
        )
            .then(({data}) => {
                const countryNames = data.map((country) => {
                    return {
                        value: country.cont_code,
                        label: country.cont_name
                    }
                });

                setCountries(countryNames);
                setIsReadyCountry(true)

            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/accounts/getCountriesFiltered`, {
                headers: {
                    "ngrok-skip-browser-warning": "69420",
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            }
        )
            .then(({data}) => {
                const countryNames = data.map((country) => {
                    return {
                        value: country.cont_code,
                        label: country.cont_name
                    }
                });

                setResidenceCountry(countryNames);
                setIsReadyCountry(true)
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);

    useEffect(() => {
        if (countries.length) {
            if (ownerData.joint_business_state) {
                getStates(ownerData.joint_business_country, '1')
            }

            if (ownerData.joint_no_state) {
                getStates(ownerData.joint_no_country, '2')
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countries]);

    const getStates = async (country, type) => {
        setIsReadyState(false);
        const countryObject = countries.find(i => i.value === country || i.label === country);

        if (!countryObject) {
            setIsReadyState(true);
            return;
        }

        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/accounts/getStates/${countryObject.value}`, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            });

            const stateData = response.data;
            const stateNames = stateData.map((state) => ({
                subdivision_name: state.subdivision_name,
                code: state.code
            }));

            setIsReadyState(true);

            setState(stateNames)
        } catch (err) {
            console.log(err.message);
        }
    }

    const isValidDate = (dateString) => {
        const regex = /^\d{2}\/\d{2}\/\d{4}$/;

        if (!regex.test(dateString)) {
            return false;
        }

        const parts = dateString.split('/');
        const year = parseInt(parts[2], 10)
        const month = parseInt(parts[0], 10) - 1;
        const day = parseInt(parts[1], 10);
        const date = new Date(year, month, day);

        return (
            date.getDate() === day &&
            date.getMonth() === month &&
            date.getFullYear() === year
        );
    };

    const [ownerErrors, setOwnerErrors] = useState({
        joint_title: '',
        joint_first_name: '',
        joint_last_name: '',
        joint_middle_name: '',
        joint_birth: '',
        joint_citizenship_status: '',
        joint_ssn: '',
        joint_confirm_ssn: '',
        joint_iden_type: '',
        joint_iden_number: '',
        joint_issue_date: '',
        joint_exp_date: '',
        joint_spouse: '',
        joint_same_add: '',
        joint_mobile_phone: '',
        joint_emp_status: '',
        joint_member: '',
        joint_indicate1: '',
        joint_indicate2: '',
        joint_occupation: '',
        joint_company_name: '',
        joint_address: '',
        joint_city: '',
        joint_business_country: '',
        joint_zip_code: '',
        joint_school_name: '',
        joint_no_address: '',
        joint_no_address2: '',
        joint_no_city: '',
        joint_no_country: '',
        joint_no_zip_code: '',
        joint_no_state: '',
        country_of_birth: '',
        country_of_residence: '',
        country_of_citizenship: '',
        clientIP: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        setOwnerErrors({
            joint_title: '',
            joint_first_name: '',
            joint_last_name: '',
            joint_middle_name: '',
            joint_birth: '',
            joint_citizenship_status: '',
            joint_ssn: '',
            joint_confirm_ssn: '',
            joint_iden_type: '',
            joint_iden_number: '',
            joint_issue_date: '',
            joint_exp_date: '',
            joint_spouse: '',
            joint_same_add: '',
            joint_mobile_phone: '',
            joint_emp_status: '',
            joint_member: '',
            joint_indicate1: '',
            joint_indicate2: '',
            joint_occupation: '',
            joint_company_name: '',
            joint_address: '',
            joint_city: '',
            joint_business_country: '',
            joint_business_state: '',
            joint_zip_code: '',
            joint_school_name: '',
            joint_no_address: '',
            joint_no_address2: '',
            joint_no_city: '',
            joint_no_country: '',
            joint_no_zip_code: '',
            joint_no_state: '',
            country_of_birth: '',
            country_of_residence: '',
            country_of_citizenship: '',
            clientIP: ''
        });

        let isValid = true;

        if (!ownerData.joint_title) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_title: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_first_name) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_first_name: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_last_name) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_last_name: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_birth || !isValidDate(ownerData.joint_birth)) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_birth: t('errors.valid_date')
            }));
            isValid = false;
        } else {
            const currentDate = new Date();
            const dobDate = new Date(ownerData.joint_birth);
            const age = currentDate.getFullYear() - dobDate.getFullYear();

            if (age < 18) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_birth: t('errors.years_old_error'),
                }));
                isValid = false;
            }
        }

        if (!ownerData.joint_citizenship_status) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_citizenship_status: t('errors.required_field'),
            }));
            isValid = false;
        }

        if( ownerData.joint_citizenship_status !== "non_resident"){
            if (!ownerData.joint_ssn) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_ssn: t('errors.required_field'),
                }));
                isValid = false;
            } else if (ownerData.joint_ssn.length !== 11) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_ssn: t('errors.enter_characters'),
                }));

                isValid = false;
            } else {
                if (ownerData.joint_ssn === personalData.ssn) {
                    setOwnerErrors((prevErrors) => ({
                        ...prevErrors,
                        joint_ssn: t('errors.main_user_ssn'),
                    }));
                    isValid = false;
                }
            }
        }

        if(ownerData.joint_citizenship_status !== "non_resident"){
            if (ownerData.joint_confirm_ssn !== ownerData.joint_ssn) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_confirm_ssn: t('errors.conf_ssn_error'),
                }));
                isValid = false;
            } else {
                if (ownerData.joint_confirm_ssn.length !== 11) {
                    setOwnerErrors((prevErrors) => ({
                        ...prevErrors,
                        joint_confirm_ssn: t('errors.enter_characters'),
                    }));

                    isValid = false;
                }
            }
        }

        if (!ownerData.joint_iden_type) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_iden_type: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_iden_number) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_iden_number: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_issue_date || !isValidDate(ownerData.joint_issue_date)) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_issue_date: t('errors.required_field'),
            }));
            isValid = false;
        } else {
            const currentDate = new Date();
            const issueDate = new Date(ownerData.joint_issue_date);

            if (issueDate > currentDate) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_issue_date: t('errors.exp_earlier_date_error'),
                }));
                isValid = false;
            }
        }

        if (!ownerData.joint_exp_date || !isValidDate(ownerData.joint_exp_date)) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_exp_date: t('errors.required_field'),
            }));
            isValid = false;
        } else {
            const currentDate = new Date();
            const selectedExpDate = new Date(ownerData.joint_exp_date);

            if (selectedExpDate < currentDate) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_exp_date: t('errors.exp_date_error'),
                }));
                isValid = false;
            } else if (ownerData.joint_issue_date && selectedExpDate <= new Date(ownerData.joint_issue_date)) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_exp_date: t('errors.exp_issue_date_error'),
                }));
                isValid = false;
            }
        }

        if (!ownerData.joint_mobile_phone) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_mobile_phone: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_emp_status) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_emp_status: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_indicate1) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_indicate1: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_indicate2) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_indicate2: t('errors.required_field'),
            }));
            isValid = false;
        }

        const totalPercentage = parseInt(ownerData.joint_indicate1, 10) + parseInt(ownerData.joint_indicate2, 10);

        if (totalPercentage !== 100) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_indicate1: t('errors.indicate_error'),
                joint_indicate2: t('errors.indicate_error')
            }));
            isValid = false;
        }

        if (!ownerData.joint_occupation && (ownerData.joint_emp_status === 'Employed' || ownerData.joint_emp_status === 'SelfEmployed')) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_occupation: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_company_name && (ownerData.joint_emp_status === 'Employed' || ownerData.joint_emp_status === 'SelfEmployed')) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_company_name: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_school_name && ownerData.joint_emp_status === 'Student') {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_school_name: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_address && (ownerData.joint_emp_status === 'Employed' || ownerData.joint_emp_status === 'SelfEmployed')) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_address: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_city && (ownerData.joint_emp_status === 'Employed' || ownerData.joint_emp_status === 'SelfEmployed')) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_city: t('errors.required_field'),
            }));
            isValid = false;
        }

        const zipCodeRegex = /^\d{5}(-\d{4})?$/;
        if (ownerData.joint_business_country === 'USA') {
            if (!zipCodeRegex.test(ownerData.joint_zip_code) && (ownerData.joint_emp_status === 'Employed' || ownerData.joint_emp_status === 'SelfEmployed')) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    zipCode: t('errors.zip_code_format'),
                }));
                isValid = false;
            }
        }

        if (!ownerData.joint_business_country && (ownerData.joint_emp_status === 'Employed' || ownerData.joint_emp_status === 'SelfEmployed')) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_business_country: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!ownerData.joint_business_state && (ownerData.joint_emp_status === 'Employed' || ownerData.joint_emp_status === 'SelfEmployed')) {
            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                joint_business_state: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (ownerData.joint_same_add === "N") {
            if (!ownerData.joint_no_address) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_no_address: t('errors.required_field'),
                }));
                isValid = false;
            }

            if (!ownerData.joint_no_city) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_no_city: t('errors.required_field'),
                }));
                isValid = false;
            }

            if (!ownerData.joint_no_country) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_no_country: t('errors.required_field'),
                }));
                isValid = false;
            }

            if (!ownerData.joint_no_state) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_no_state: t('errors.required_field'),
                }));
                isValid = false;
            }

            if (!zipCodeRegex.test(ownerData.joint_no_zip_code) && ownerData.joint_no_country === 'USA') {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    zipCode: t('errors.zip_code_format'),
                }));
                isValid = false;
            }
        }

        if (ownerData.joint_citizenship_status === "non_resident" || ownerData.joint_citizenship_status === "ResidentAlien") {
            if (!ownerData.country_of_birth) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    country_of_birth: t('errors.required_field'),
                }));
                isValid = false;
            }

            if (ownerData.joint_citizenship_status === "non_resident" && !ownerData.country_of_residence) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    country_of_residence: t('errors.required_field'),
                }));
                isValid = false;
            }

            if (!ownerData.country_of_citizenship) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    country_of_citizenship: t('errors.required_field'),
                }));
                isValid = false;
            }
        }

        if (isValid) {
            setOwnerData(ownerData);
            if (!appData.app_id) alert('Missing app id')

            try {
                await ownerApp()
                navigate('/conditions')
            } catch (error) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    submitError: error.message,
                }));
            }
        }
    };

    const handleInputChange = (e) => {
        let {name, value} = e.target;

        if (name === 'joint_ssn' || name === 'joint_confirm_ssn') {
            value = value.replace(/\D/g, '');

            if (value.length === 9) {
                value = value.replace(/^(\d{3})(\d{2})(\d{4})$/, '$1-$2-$3');
            }

            setOwnerData((prevData) => ({
                ...prevData,
                [name]: value
            }));
        }

        if (name === 'joint_ssn') {
            if (!value) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_ssn: t('errors.required_field'),
                }));
            } else{
                if (value === personalData.ssn) {
                    setOwnerErrors((prevErrors) => ({
                        ...prevErrors,
                        joint_ssn: t('errors.main_user_ssn'),
                    }));
                } if (value.length === 11 && value.match(/^\d{3}-\d{2}-\d{4}$/)){
                    setOwnerErrors((prevErrors) => ({
                        ...prevErrors,
                        joint_ssn: '',
                    }));
                }  else {
                    setOwnerErrors((prevErrors) => ({
                        ...prevErrors,
                        joint_ssn: t('errors.enter_characters'),
                    }));
                }
            }
        }

        if (name === 'joint_confirm_ssn') {
            if (value !== ownerData.joint_ssn) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    joint_confirm_ssn: t('errors.conf_ssn_error'),
                }));
            } else {
                if (value.length === 11 && value.match(/^\d{3}-\d{2}-\d{4}$/)) {
                    setOwnerErrors((prevErrors) => ({
                        ...prevErrors,
                        joint_confirm_ssn: '',
                    }));
                } else {
                    setOwnerErrors((prevErrors) => ({
                        ...prevErrors,
                        joint_confirm_ssn: t('errors.enter_characters'),
                    }));
                }
            }
        }

        if (name === 'joint_birth' || name === 'joint_exp_date' || name === 'joint_issue_date') {
            const numericValue = value.replace(/\D/g, '');

            if (numericValue.length <= 2) {
                value = numericValue;
            } else if (numericValue.length <= 4) {
                value = `${numericValue.substr(0, 2)}/${numericValue.substr(2)}`;
            } else {
                value = `${numericValue.substr(0, 2)}/${numericValue.substr(2, 2)}/${numericValue.substr(4, 4)}`;
            }

            const isValid = isValidDate(value);

            setOwnerErrors((prevErrors) => ({
                ...prevErrors,
                [name]: isValid ? '' : t('errors.valid_date'),
            }));

            if (isValid) {
                const currentDate = new Date();
                const dateValue = new Date(value);

                if (name === 'joint_birth') {
                    const age = currentDate.getFullYear() - dateValue.getFullYear();
                    if (age < 18) {
                        setOwnerErrors((prevErrors) => ({
                            ...prevErrors,
                            [name]: t('errors.years_old_error'),
                        }));
                    }
                } else if (name === 'joint_issue_date') {
                    if (dateValue > currentDate) {
                        setOwnerErrors((prevErrors) => ({
                            ...prevErrors,
                            [name]: t('errors.exp_earlier_date_error'),
                        }));
                    }
                } else if (name === 'joint_exp_date') {
                    if (dateValue < currentDate) {
                        setOwnerErrors((prevErrors) => ({
                            ...prevErrors,
                            [name]: t('errors.exp_date_error'),
                        }));
                    } else if (ownerData.joint_issue_date && dateValue <= new Date(ownerData.joint_issue_date)) {
                        setOwnerErrors((prevErrors) => ({
                            ...prevErrors,
                            [name]: t('errors.exp_issue_date_error'),
                        }));
                    }
                }
            }
        }

        if (name === 'joint_zip_code' || name === 'joint_no_zip_code') {
            value = value.replace(/\D/g, '').substr(0, 9);

            if (value.length === 9) {
                value = `${value.substr(0, 5)}-${value.substr(5, 4)}`;
            }

            const zipCodeRegex = /^\d{5}(-\d{4})?$/;
            if (!zipCodeRegex.test(value)) {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: t('errors.zip_code_format'),
                }));
            } else {
                setOwnerErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: '',
                }));
            }
        }

        setOwnerData({
            ...ownerData,
            [name]: value,
        });
    };

    const formatDateInput = (dateString) => {
        if (!dateString) return dateString
        return dateString.replace(/\D/g, '').replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3');
    };

    const formatDateInputAPI = (dateString) => {
        if (!dateString) return dateString
        return dateString.replace(/\D/g, '').replace(/(\d{2})(\d{2})(\d{4})/, '$3-$1-$2');
    };

    const getOwnerValues = () => {
        return {
            JointMemberOther: ownerData.joint_member,
        }
    };

    const ownerApp = async () => {
        try {
            const URL = HOST + appData.app_id
            const params = getOwnerValues()

            if (ownerData.joint_citizenship_status === 'ResidentAlien') {
                delete ownerData.country_of_residence
            } else if (ownerData.joint_citizenship_status === 'UsCitizen') {
                delete ownerData.country_of_birth
                delete ownerData.country_of_citizenship
                delete ownerData.country_of_residence
            }

            const parsedOwnerData = {
                ...ownerData,
                joint_birth: formatDateInputAPI(ownerData.joint_birth),
                joint_exp_date: formatDateInputAPI(ownerData.joint_exp_date),
                joint_issue_date: formatDateInputAPI(ownerData.joint_issue_date)
            }

            const response = await axios.put(URL, {
                ...parsedOwnerData,
                ...params
            }, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            })

            if (response.data && response.data.status && ['404', '500'].includes(response.data.status)) {
                throw new Error(response.data.message || 'Unknown error occurred');
            }

        } catch (error) {
            throw error;
        }
    }

    const handleOwnerTypeChange = (newOwnerType) => {
        setOwnerType(newOwnerType);
    };

    const handleSameAddTypeChange = (newOwnerType) => {
        setSameAddType(newOwnerType);
    };

    const handleSpouseChange = (newOwnerType) => {
        setSpouseType(newOwnerType);
    };

    const onChangeOwnerCountry = async (value) => {
        setOwnerData({...ownerData, 'joint_no_country': value});
        await getStates(value, '2')
    }

    const onChangeBirthCountry = (value) => {
        setOwnerData({...ownerData, 'country_of_birth': value});
    }

    const onChangeCountryResidence = (value) => {
        setOwnerData({...ownerData, 'country_of_residence': value});
    }

    const onChangeCountryCitizenship = (value) => {
        setOwnerData({...ownerData, 'country_of_citizenship': value});
    }

    const onChangeBusinessCountry = async (value) => {
        setOwnerData({...ownerData, 'joint_business_country': value});
        await getStates(value, '1')
    }

    const onChangeState = (value) => {
        setOwnerData({...ownerData, 'joint_no_state': value});
    }

    const onChangeBusinessState = (value) => {
        setOwnerData({...ownerData, 'joint_business_state': value});
    }

    return (
        <div className="owner_info">
            <div className="owner_info_left_side">
                <img src={review_logo} alt=""/>
                <img style={{paddingTop: "12%"}} src={personal_img} alt=""/>
            </div>
            <div className="owner_info_right_side">
                <Logout/>
                <div>
                    <p className="owner_info_heading">{t('joint.thanks')} {personalData.firstName} {personalData.lastName}. {t('joint.provide_joint_info')}</p>
                    <p className="owner_info_heading">{t('joint.joint_info')}</p>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="owner_info_inputs">
                        <div className="owner_info_input_error">
                            <Form.Select aria-label="Default select example"
                                         name="joint_title"
                                         value={ownerData.joint_title}
                                         onChange={handleInputChange}
                            >
                                <option>{t('personal.title')}</option>
                                <option value="Mr.">{t('personal.mr')}</option>
                                <option value="Ms.">{t('personal.ms')}</option>
                                <option value="Mrs.">{t('personal.mrs')}</option>
                                <option value="Dr.">{t('personal.dr')}</option>
                            </Form.Select>
                            {ownerErrors.joint_title && <p className="error">{ownerErrors.joint_title}</p>}
                        </div>
                        <div className="owner_info_input_error">
                            <input className="owner_info_input" placeholder={t('personal.first_name')}
                                   type="text"
                                   name="joint_first_name"
                                   value={ownerData.joint_first_name}
                                   onChange={handleInputChange}
                            />
                            {ownerErrors.joint_first_name && <p className="error">{ownerErrors.joint_first_name}</p>}
                        </div>
                        <div className="owner_info_inp_full_error">
                            <input className="owner_info_input" placeholder={t('specialty.middle_name')}
                                   type="text"
                                   name="joint_middle_name"
                                   value={ownerData.joint_middle_name}
                                   onChange={handleInputChange}
                            />
                        </div>
                        <div className="owner_info_input_error">
                            <input className="owner_info_input" placeholder={t('personal.last_name')}
                                   type="text"
                                   name="joint_last_name"
                                   value={ownerData.joint_last_name}
                                   onChange={handleInputChange}
                            />
                            {ownerErrors.joint_last_name && <p className="error">{ownerErrors.joint_last_name}</p>}
                        </div>
                        <div className="owner_info_input_error">
                            <input
                                className="owner_info_input"
                                placeholder={t('personal.date_of_birth')}
                                type="text"
                                name="joint_birth"
                                value={formatDateInput(ownerData.joint_birth)}
                                onChange={handleInputChange}
                            />
                            {ownerErrors.joint_birth && <p className="error">{ownerErrors.joint_birth}</p>}
                        </div>
                        <div className="owner_info_inp_full_error">
                            <Form.Select aria-label="Default select example"
                                         name="joint_citizenship_status"
                                         value={ownerData.joint_citizenship_status}
                                         onChange={handleInputChange}
                            >
                                <option>{t('register.citizen_status')}</option>
                                <option value="UsCitizen">U.S. Citizen</option>
                                <option value="ResidentAlien">Resident Alien</option>
                                <option value="non_resident">Non Resident</option>
                            </Form.Select>
                            {ownerErrors.joint_citizenship_status &&
                                <p className="error">{ownerErrors.joint_citizenship_status}</p>}
                        </div>

                        {
                            (ownerData.joint_citizenship_status === "non_resident" || ownerData.joint_citizenship_status === "ResidentAlien") && (
                                <>
                                    <div className="owner_info_input_error" style={{textAlign: "center"}}>
                                        {
                                            isReadyCountry ?
                                                <select className="owner_country_select" value={ownerData.country_of_birth}
                                                        onChange={(e) => onChangeBirthCountry(e.target.value)}
                                                        name="country_of_birth">
                                                    <option>Country Of Birth</option>
                                                    {countries.map((country, index) =>
                                                        <option value={country.value} key={index.toString()}>
                                                            {country.label}
                                                        </option>)}
                                                </select>
                                                : <Spinner animation="border" role="status" variant="personalData">
                                                    <span className="visually-hidden">Loading...</span>
                                                </Spinner>
                                        }

                                        {isReadyCountry && ownerErrors.country_of_birth &&
                                            <p className="info_error">{ownerErrors.country_of_birth}</p>}
                                    </div>

                                    <div className="owner_info_input_error" style={{textAlign: "center"}}>
                                        {
                                            isReadyCountry ?
                                                <select className="owner_country_select"
                                                        value={ownerData.country_of_citizenship}
                                                        onChange={(e) => onChangeCountryCitizenship(e.target.value)}
                                                        name="country_of_citizenship">
                                                    <option>Country of Citizenship</option>
                                                    {countries.map((country, index) => <option value={country.value}
                                                                                               key={index.toString()}>{country.label}</option>)}
                                                </select>
                                                : <Spinner animation="border" role="status" variant="personalData">
                                                    <span className="visually-hidden">Loading...</span>
                                                </Spinner>
                                        }

                                        {isReadyCountry && ownerErrors.country_of_citizenship &&
                                            <p className="info_error">{ownerErrors.country_of_citizenship}</p>}
                                    </div>

                                    {ownerData.joint_citizenship_status === "non_resident" &&

                                        <div className="owner_info_inp_full_error" style={{textAlign: "center"}}>
                                            {
                                                isReadyCountry ?
                                                    <select className="owner_country_select"
                                                            value={ownerData.country_of_residence}
                                                            onChange={(e) => onChangeCountryResidence(e.target.value)}
                                                            name="country_of_residence">
                                                        <option>Country Of Residence</option>
                                                        {residenceCountry.map((country, index) => <option
                                                            value={country.value}
                                                            key={index.toString()}>{country.label}</option>)}
                                                    </select>
                                                    : <Spinner animation="border" role="status" variant="personalData">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </Spinner>
                                            }

                                            {isReadyCountry && ownerErrors.country_of_residence &&
                                                <p className="info_error">{ownerErrors.country_of_residence}</p>}
                                        </div>
                                    }
                                </>
                            )
                        }

                        {ownerData.joint_citizenship_status !== "non_resident" &&
                            <>
                                <div className="owner_info_input_error">
                                    <input className="personal_input" placeholder={t('personal.ssn')} type="text"
                                           name="joint_ssn"
                                           maxLength={11}
                                           value={ownerData.joint_ssn}
                                           onChange={handleInputChange}
                                    />
                                    {ownerErrors.joint_ssn && <p className="error">{ownerErrors.joint_ssn}</p>}
                                </div>
                                <div className="owner_info_input_error">
                                    <input className="personal_input" placeholder={t('personal.confirm_ssn')}
                                           type="text"
                                           name="joint_confirm_ssn"
                                           maxLength={11}
                                           value={ownerData.joint_confirm_ssn}
                                           onChange={handleInputChange}
                                    />
                                    {ownerErrors.joint_confirm_ssn &&
                                        <p className="error">{ownerErrors.joint_confirm_ssn}</p>}
                                </div>
                            </>
                        }

                        <div className="owner_info_input_error">
                            <Form.Select aria-label="Default select example"
                                         name="joint_iden_type"
                                         value={ownerData.joint_iden_type}
                                         onChange={handleInputChange}
                            >
                                <option>{t('personal.iden_type')}</option>
                                <option value="drivers_license">{t('personal.state_dl')}</option>
                                <option value="identity_card">{t('personal.state_id')}</option>
                                <option value="passport">{t('personal.passport')}</option>
                            </Form.Select>
                            {ownerErrors.joint_iden_type && <p className="error">{ownerErrors.joint_iden_type}</p>}
                        </div>
                        <div className="owner_info_input_error">
                            <input className="owner_info_input" placeholder={t('personal.iden_number')} type="number"
                                   name="joint_iden_number"
                                   value={ownerData.joint_iden_number}
                                   onChange={handleInputChange}
                            />
                            {ownerErrors.joint_iden_number && <p className="error">{ownerErrors.joint_iden_number}</p>}
                        </div>
                        <div className="owner_info_input_error">
                            <input className="owner_info_input"
                                   placeholder={t('personal.issue_date')}
                                   type="text"
                                   name="joint_issue_date"
                                   value={formatDateInput(ownerData.joint_issue_date)}
                                   onChange={handleInputChange}
                            />
                            {ownerErrors.joint_issue_date && <p className="error">{ownerErrors.joint_issue_date}</p>}
                        </div>
                        <div className="owner_info_input_error">
                            <input className="owner_info_input"
                                   placeholder={t('personal.expiration_date')}
                                   type="text"
                                   name="joint_exp_date"
                                   value={formatDateInput(ownerData.joint_exp_date)}
                                   onChange={handleInputChange}
                            />
                            {ownerErrors.joint_exp_date && <p className="error">{ownerErrors.joint_exp_date}</p>}
                        </div>
                        <div style={{display: "flex", gap: "12px", paddingTop: "3%", paddingBottom: "2%"}}>
                            <div style={{width: "50%"}}>
                                <p>{t('joint.joint_account_spouse')}</p>
                                <div style={{display: "flex", gap: "15px"}}>
                                    <div style={{display: "flex", gap: "7px"}}>
                                        <input type="radio"
                                               name="joint_spouse"
                                               value="Y"
                                               onChange={() => handleSpouseChange('Y')}
                                               checked={ownerData.joint_spouse === "Y"}
                                        />
                                        <label>{t('joint.yes')}</label>
                                    </div>
                                    <div style={{display: "flex", gap: "7px"}}>
                                        <input type="radio"
                                               name="joint_spouse"
                                               value="N"
                                               onChange={() => handleSpouseChange('N')}
                                               checked={ownerData.joint_spouse === "N"}
                                        />
                                        <label>{t('joint.no')}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="part2_options">
                                <p>{t('joint.joint_primary_address')}</p>
                                <div style={{display: "flex", gap: "15px"}}>
                                    <div style={{display: "flex", gap: "7px"}}>
                                        <input type="radio"
                                               name="joint_same_add"
                                               value="Y"
                                               onChange={() => handleSameAddTypeChange('Y')}
                                               checked={ownerData.joint_same_add === "Y"}
                                        />
                                        <label>{t('joint.yes')}</label>
                                    </div>
                                    <div style={{display: "flex", gap: "7px"}}>
                                        <input type="radio"
                                               name="joint_same_add"
                                               value="N"
                                               onChange={() => handleSameAddTypeChange('N')}
                                               checked={ownerData.joint_same_add === "N"}
                                        />
                                        <label>{t('joint.no')}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {ownerData.joint_same_add === "N" &&
                            <>
                                <div className="owner_info_input_error">
                                    <input className="owner_info_input" placeholder="Join Owner Address"
                                           type="text"
                                           name="joint_no_address"
                                           value={ownerData.joint_no_address}
                                           onChange={handleInputChange}
                                    />
                                    {ownerErrors.joint_no_address &&
                                        <p className="error">{ownerErrors.joint_no_address}</p>}
                                </div>
                                <div className="owner_info_input_error">
                                    <input className="owner_info_input" placeholder="Address2"
                                           type="text"
                                           name="joint_no_address2"
                                           value={ownerData.joint_no_address2}
                                           onChange={handleInputChange}
                                    />
                                </div>
                                <div className="owner_info_input_error">
                                    <input className="owner_info_input" placeholder="City"
                                           type="text"
                                           name="joint_no_city"
                                           value={ownerData.joint_no_city}
                                           onChange={handleInputChange}
                                    />
                                    {ownerErrors.joint_no_city &&
                                        <p className="error">{ownerErrors.joint_no_city}</p>}
                                </div>
                                <div className="owner_info_input_error">
                                    <input className="owner_info_input" placeholder="Zip code"
                                           type="text"
                                           name="joint_no_zip_code"
                                           value={ownerData.joint_no_zip_code}
                                           onChange={handleInputChange}
                                    />
                                    {ownerErrors.joint_no_zip_code &&
                                        <p className="error">{ownerErrors.joint_no_zip_code}</p>}
                                </div>
                                <div className="owner_info_input_error">
                                    {
                                        isReadyCountry ?
                                            <>
                                                <select className="owner_country_select"
                                                        value={ownerData.joint_no_country}
                                                        onChange={(e) => onChangeOwnerCountry(e.target.value)}
                                                        name="joint_no_country">
                                                    <option>{t('financial.select_country')}</option>
                                                    {residenceCountry.map((country, index) => <option
                                                        value={country.value}
                                                        key={index.toString()}>{country.label}</option>)}
                                                </select>
                                                <TooltipComponent/>
                                            </>
                                            : <Spinner animation="border" role="status" variant="info">
                                                <span className="visually-hidden">Loading...</span>
                                            </Spinner>
                                    }

                                    {isReadyCountry && ownerErrors.joint_no_country &&
                                        <p className="error">{ownerErrors.joint_no_country}</p>}
                                </div>
                                <div className="personal_input_error" style={{textAlign: "center"}}>
                                    {
                                        isReadyState ?
                                            <>
                                                <select className="personal_state_select"
                                                        onChange={(e) => onChangeState(e.target.value)}
                                                        name="joint_no_state"
                                                        value={ownerData.joint_no_state}>
                                                    <option>{t('personal.select_state')}</option>
                                                    {states.map((state) => <option value={state.code}
                                                                                   key={state.code}>{state.subdivision_name}</option>)}
                                                </select>
                                                <StateTooltipComponent/>
                                            </>
                                            : <span></span>
                                    }
                                    {isReadyState && ownerErrors.joint_no_state &&
                                        <p className="info_error">{ownerErrors.joint_no_state}</p>}
                                </div>
                            </>
                        }

                        <div className="owner_info_input_error">
                            <input className="owner_info_input" placeholder={t('personal.mobile_phone')}
                                   type="number"
                                   name="joint_mobile_phone"
                                   value={ownerData.joint_mobile_phone}
                                   onChange={handleInputChange}
                            />
                            {ownerErrors.joint_mobile_phone &&
                                <p className="error">{ownerErrors.joint_mobile_phone}</p>}
                        </div>
                        <div className="owner_info_input_error">
                            <Form.Select aria-label="Default select example"
                                         name="joint_emp_status"
                                         value={ownerData.joint_emp_status}
                                         onChange={handleInputChange}
                            >
                                <option>{t('financial.employment_status')}</option>
                                <option value="Employed">{t('financial.employed')}</option>
                                <option value="SelfEmployed">{t('financial.self_employed')}</option>
                                <option value="Retired">{t('financial.retired')}</option>
                                <option value="Homemaker">{t('financial.homemaker')}</option>
                                <option value="Student">{t('financial.student')}</option>
                                <option value="Unemployed">{t('financial.unemployed')}</option>
                            </Form.Select>
                            {ownerErrors.joint_emp_status && <p className="error">{ownerErrors.joint_emp_status}</p>}
                        </div>
                        {ownerData.joint_emp_status === 'Student' && (
                            <div style={{width: "100%"}}>
                                <input type="text"
                                       className="owner_info_input"
                                       placeholder={t('financial.school_name')}
                                       name="joint_school_name"
                                       value={ownerData.joint_school_name}
                                       onChange={handleInputChange}
                                />
                                {ownerErrors.joint_school_name &&
                                    <p className="error">{ownerErrors.joint_school_name}</p>}
                            </div>
                        )}
                        {(ownerData.joint_emp_status === 'SelfEmployed' || ownerData.joint_emp_status === 'Employed') && (
                            <div style={{width: "100%"}}>
                                {ownerData.joint_emp_status === 'Employed' && (
                                    <p className="owner_info_heading">{t('financial.employed')}</p>
                                )}
                                {ownerData.joint_emp_status === 'SelfEmployed' && (
                                    <p className="owner_info_heading">{t('financial.self_employed')}</p>
                                )}

                                <div className="owner_employed">
                                    <div>
                                        <Form.Select aria-label="Default select example"
                                                     name="joint_occupation"
                                                     value={ownerData.joint_occupation}
                                                     onChange={handleInputChange}
                                        >
                                            <option>{t('financial.occupation')}</option>
                                            <option value="Accounting">{t('financial.accounting')}</option>
                                            <option value="Agriculture">{t('financial.agriculture')}</option>
                                            <option value="Banking">{t('financial.banking_and_finance')}</option>
                                            <option value="Clerical">{t('financial.clerical')}</option>
                                            <option value="Construction">{t('financial.construction')}</option>
                                            <option value="Consulting">{t('financial.consulting')}</option>
                                            <option value="Customer Service">{t('financial.customer_service')}
                                            </option>
                                            <option value="Education">{t('financial.education')}</option>
                                            <option value="Engineering">{t('financial.engineer')}</option>
                                            <option value="Government">{t('financial.government')}</option>
                                            <option value="Healthcare">{t('financial.healthcare')}</option>
                                            <option value="Hotel">{t('financial.hotel_restaurant')}</option>
                                            <option value="Information Technology">{t('financial.information')}</option>
                                            <option value="Internet-E-Commerce">{t('financial.internet')}</option>
                                            <option value="Legal">{t('financial.legal')}</option>
                                            <option
                                                value="Management">{t('financial.management_executive')}</option>
                                            <option value="Manufacturing">{t('financial.manufacturing')}</option>
                                            <option value="Marketing">{t('financial.marketing')}</option>
                                            <option
                                                value="Media-Journalism-Newspaper-Magazine">{t('financial.media')}</option>
                                            <option value="Non-profit">{t('financial.non_profit')}</option>
                                            <option value="Real Estate">{t('financial.real_estate')}</option>
                                            <option value="Retail">{t('financial.retail')}</option>
                                            <option value="Sales">{t('financial.sales')}</option>
                                            <option value="Science">{t('financial.science')}</option>
                                            <option value="Security">{t('financial.security')}</option>
                                            <option value="Sports-Entertainment">{t('financial.sports')}</option>
                                            <option value="Travel-Leisure-Tourism">{t('financial.travel')}</option>
                                            <option value="Wholesale">{t('financial.wholesale')}</option>
                                        </Form.Select>
                                        {ownerErrors.joint_occupation &&
                                            <p className="error">{ownerErrors.joint_occupation}</p>}
                                    </div>
                                    <div className="employed_forms">
                                        <div className="owner_info_input_error">
                                            <input type="text"
                                                   className="owner_info_input"
                                                   placeholder={t('financial.company_name')}
                                                   name="joint_company_name"
                                                   value={ownerData.joint_company_name}
                                                   onChange={handleInputChange}
                                            />
                                            {ownerErrors.joint_company_name &&
                                                <p className="error">{ownerErrors.joint_company_name}</p>}
                                        </div>

                                        <div className="owner_info_input_error">
                                            <input type="text"
                                                   className="owner_info_input" style={{marginBottom: 0}}
                                                   placeholder={t('financial.business_address')}
                                                   name="joint_address"
                                                   value={ownerData.joint_address}
                                                   onChange={handleInputChange}
                                            />
                                            {ownerErrors.joint_address &&
                                                <p className="error">{ownerErrors.joint_address}</p>}
                                        </div>
                                    </div>
                                    <div className="employed_forms">
                                        <div className="owner_info_input_error">
                                            <input type="text"
                                                   className="owner_info_input"
                                                   placeholder={t('financial.city')}
                                                   name="joint_city"
                                                   value={ownerData.joint_city}
                                                   onChange={handleInputChange}
                                            />
                                            {ownerErrors.joint_city &&
                                                <p className="error">{ownerErrors.joint_city}</p>}
                                        </div>
                                        <div className="owner_info_input_error">
                                            {
                                                isReadyCountry ?
                                                    <select className="owner_country_select"
                                                            value={ownerData.joint_business_country}
                                                            onChange={(e) => onChangeBusinessCountry(e.target.value)}
                                                            name="joint_business_country">
                                                        <option>{t('financial.select_country')}</option>
                                                        {countries.map((country, index) => <option value={country.value}
                                                                                                   key={index.toString()}>{country.label}</option>)}
                                                    </select>
                                                    : <Spinner animation="border" role="status" variant="info">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </Spinner>
                                            }

                                            {isReadyCountry && ownerErrors.joint_business_country &&
                                                <p className="error">{ownerErrors.joint_business_country}</p>}
                                        </div>
                                    </div>
                                    <div className="employed_forms">
                                        <div className="owner_info_input_error">
                                            <input type="text"
                                                   className="owner_info_input"
                                                   placeholder={t('financial.zip_code')}
                                                   name="joint_zip_code"
                                                   value={ownerData.joint_zip_code}
                                                   onChange={handleInputChange}
                                            />
                                            {ownerErrors.joint_zip_code &&
                                                <p className="error">{ownerErrors.joint_zip_code}</p>}
                                        </div>
                                        <div className="personal_input_error" style={{textAlign: "center"}}>
                                            {
                                                isReadyState ?
                                                    <select className="personal_state_select"
                                                            onChange={(e) => onChangeBusinessState(e.target.value)}
                                                            name="joint_business_state"
                                                            value={ownerData.joint_business_state}>
                                                        <option>{t('personal.select_state')}</option>
                                                        {states.map((state) => <option value={state.code}
                                                                                       key={state.code}>{state.subdivision_name}</option>)}
                                                    </select>
                                                    : <span></span>
                                            }
                                            {isReadyState && ownerErrors.joint_business_state &&
                                                <p className="info_error">{ownerErrors.joint_business_state}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div style={{paddingTop: "2%"}}>
                            <p>
                                {t('joint.are_you_member')}
                            </p>
                            <div style={{display: "flex", gap: "15px"}}>
                                <div style={{display: "flex", gap: "7px"}}>
                                    <input type="radio"
                                           name="joint_member"
                                           onChange={() => handleOwnerTypeChange('Y')}
                                           checked={ownerData.joint_member === "Y"}
                                    />
                                    <label> {t('joint.yes')}</label>
                                </div>
                                <div style={{display: "flex", gap: "7px"}}>
                                    <input type="radio"
                                           name="joint_member"
                                           onChange={() => handleOwnerTypeChange('N')}
                                           checked={ownerData.joint_member === "N"}
                                    />
                                    <label> {t('joint.no')}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{paddingTop: "4%"}}>
                        <p className="owner_info_heading" style={{textAlign: "center"}}> {t('joint.indicate')}</p>
                        <div className="indicate_forms">
                            <div className="owner_pers_data" style={{width: "53%"}}>
                                <span>{personalData.firstName} {personalData.lastName}:</span>

                                <div className="owner_info_input_error" style={{width: "53%"}}>
                                    <input style={{width: "100%"}} className="owner_info_input" placeholder="0"
                                           type="text"
                                           name="joint_indicate1"
                                           maxLength={3}
                                           value={ownerData.joint_indicate1}
                                           onChange={handleInputChange}
                                    />
                                    <span>%</span>
                                    {ownerErrors.joint_indicate1 &&
                                        <p className="error">{ownerErrors.joint_indicate1}</p>}
                                </div>
                            </div>
                            <div className="owner_pers_data" style={{width: "53%"}}>
                                <span>{ownerData.joint_first_name} {ownerData.joint_last_name}:</span>

                                <div className="owner_info_input_error" style={{width: "53%"}}>
                                    <input style={{width: "100%"}} className="owner_info_input" placeholder="0"
                                           type="text"
                                           name="joint_indicate2"
                                           maxLength={3}
                                           value={ownerData.joint_indicate2}
                                           onChange={handleInputChange}
                                    />
                                    <span>%</span>
                                    {ownerErrors.joint_indicate2 &&
                                        <p className="error">{ownerErrors.joint_indicate2}</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="owner_btn">
                        <Link style={{textDecoration: "none"}} to="/experience">
                            <button className="owner_back_btn">{t('back_btn')}</button>
                        </Link>
                        <button className="owner_continue_btn" type="submit">{t('next_btn')}</button>
                    </div>
                    <div>
                        {ownerErrors.submitError && (
                            <div style={{color: 'red', textAlign: "center"}}>
                                {ownerErrors.submitError}
                            </div>
                        )}
                    </div>
                </form>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    ownerData: state.ownerData,
    personalData: state.personalData,
    appData: state.appData
});

const mapDispatchToProps = {
    setOwnerData,
    setOwnerType,
    setSameAddType,
    setSpouseType
};

export default connect(mapStateToProps, mapDispatchToProps)(OwnerPersonalInfo);